import { forwardRef, useImperativeHandle, useRef } from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'

import styles from './Captcha.module.scss'

const CAPTCHA_HOST = 'wisprflow.ai'
export interface CaptchaRef {
  reset: () => void
}

interface CaptchaProps {
  onVerify: (token: string) => void
  onExpire?: () => void
  onError?: (error: string) => void
}

const Captcha = forwardRef<CaptchaRef, CaptchaProps>(({ onVerify, onExpire, onError }, ref) => {
  const captchaRef = useRef<HCaptcha>(null)
  const siteKey = import.meta.env.VITE_CAPTCHA_SITE_KEY

  useImperativeHandle(ref, () => ({
    reset: () => captchaRef.current?.resetCaptcha(),
  }))

  if (!siteKey) {
    console.error('VITE_CAPTCHA_SITE_KEY environment variable is not set')
    return <div className={styles.error}>Captcha configuration error</div>
  }

  return (
    <div className={styles.container}>
      <HCaptcha
        host={CAPTCHA_HOST}
        ref={captchaRef}
        sitekey={siteKey}
        onVerify={onVerify}
        onExpire={onExpire}
        onError={onError}
      />
    </div>
  )
})

Captcha.displayName = 'Captcha'

export default Captcha
